import classNames from "components/ui/classNames";
import { useAmplitude } from "lib/amplitude/Amplitude";
import type { ICommentOrReplyAuthorFieldsFragment } from "lib/graphql/fragments/__generated__/CommentOrReplyAuthorFields.generated";
import useSelfie from "lib/hooks/useSelfie";
import Link from "next/link";
import { FormattedMessage } from "react-intl";

type User = Pick<ICommentOrReplyAuthorFieldsFragment, "isBlack" | "isSiteAdmin">;

interface TagsProps {
  viewer: User;
}
export default function Tags({ viewer }: TagsProps) {
  const { isSiteAdmin, isBlack } = viewer;

  if (isSiteAdmin) {
    return <ModeratorTag />;
  }

  if (isBlack) {
    return <BlackTag />;
  }

  return null;
}

export function BlackTag() {
  const viewer = useSelfie();
  const amplitude = useAmplitude();
  const tag = (
    <span
      className={classNames(
        "rounded-md px-1.5 py-1 font-aeonik text-xs font-bold tracking-wider",
        "bg-neutral-700 text-white",
        "dark:bg-neutral-500/10 dark:text-neutral-200",
      )}
    >
      Black
    </span>
  );

  if (viewer?.isBlack) {
    return tag;
  }
  return (
    <Link
      href="https://hotm.art/HqMWAP0"
      target="_blank"
      onClick={() => {
        amplitude.logEvent("Click on link to become Black", {
          origin: "Tag",
        });
      }}
    >
      {tag}
    </Link>
  );
}

export function ModeratorTag() {
  return (
    <span
      className={classNames(
        "rounded-md px-1.5 py-1 font-aeonik text-xs font-bold tracking-wider",
        "bg-orange-100 text-orange-800 dark:bg-orange-600/10 dark:text-orange-300",
      )}
    >
      <FormattedMessage defaultMessage="Moderador" id="5RDJ+m" description="Tag de moderador" />
    </span>
  );
}
